import { IconButton, InputAdornment } from "@material-ui/core";
import { Eye, EyeClosed } from 'lucide-react';
import React, { useState } from "react";
import { CheckmarkCircle, CheckmarkCircleOutline } from 'react-ionicons';
import BetterTextField from "../BetterTextField";
import BetterButton from "../BetterButton";
import Swal from 'sweetalert2';
import { swalCustom } from "../../utils/Utils";

export default function ValidarSenha({ handle, textoBotao = 'Continuar', loading }) {
	const [senha, setSenha] = useState('');
	const [confirmaSenha, setConfirmaSenha] = useState('');

	const [showSenha, setShowSenha] = useState(false);
	const [showConfirmaSenha, setShowConfirmaSenha] = useState(false);

	const preHandle = () => {
		let valid = true;

		if (senha.length < 8) valid = false;
		if (!/[0-9]/.test(senha)) valid = false;
		if (!/[a-z]/.test(senha)) valid = false;
		if (!/[A-Z]/.test(senha)) valid = false;
		if (!/[!@#$%^&*(),.?":{}|<>+\-=\/_;]/.test(senha)) valid = false;

		if (!valid) return swalCustom("Ops!", 'A senha não corresponde aos requisitos minimos', 'info');

		if (senha !== confirmaSenha) return swalCustom("Ops!", 'As senhas são diferentes.', 'info');

		handle(senha);
	}

	return (
		<div className="senha-wrapper">
			<div className="row">
				<div className="col-sm-12">
					<BetterTextField required type={showSenha ? 'text' : "password"} name="password" label={'Nova senha'} placeholder={'Nova senha'} onChange={(e) => setSenha(e.target.value)} value={senha} InputProps={{
						endAdornment:
							<InputAdornment position="end">
								<IconButton
									onClick={() => setShowSenha(!showSenha)}
									edge="end"
								>
									{showSenha ? <Eye /> : <EyeClosed />}
								</IconButton>
							</InputAdornment>
					}} />
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<BetterTextField required type={showConfirmaSenha ? 'text' : "password"} name="confirm-password" label={'Confirme sua nova senha'} placeholder={'Confirme sua nova senha'} onChange={(e) => setConfirmaSenha(e.target.value)} value={confirmaSenha} InputProps={{
						endAdornment:
							<InputAdornment position="end">
								<IconButton
									onClick={() => setShowConfirmaSenha(!showConfirmaSenha)}
									edge="end"
								>
									{showConfirmaSenha ? <Eye /> : <EyeClosed />}
								</IconButton>
							</InputAdornment>
					}} />
				</div>
			</div>

			<div className="lista-senha">
				<p className="titulo-senha">Sua senha deve conter no mínimo:</p>

				<p className="item-senha">
					{(senha?.length >= 8) ? <CheckmarkCircle color={'#2E7D32'} /> : <CheckmarkCircleOutline color={'#555'} />}
					8 caracteres
				</p>

				<p className="item-senha">
					{/[0-9]/.test(senha) ? <CheckmarkCircle color={'#2E7D32'} /> : <CheckmarkCircleOutline color={'#555'} />}
					1 número
				</p>

				<p className="item-senha">
					{/[a-z]/.test(senha) ? <CheckmarkCircle color={'#2E7D32'} /> : <CheckmarkCircleOutline color={'#555'} />}
					1 letra minúscula
				</p>

				<p className="item-senha">
					{/[A-Z]/.test(senha) ? <CheckmarkCircle color={'#2E7D32'} /> : <CheckmarkCircleOutline color={'#555'} />}
					1 letra maiúscula
				</p>

				<p className="item-senha">
					{/[!@#$%^&*(),.?":{}|<>+\-=\/_;]/.test(senha) ? <CheckmarkCircle color={'#2E7D32'} /> : <CheckmarkCircleOutline color={'#555'} />}
					1 caractere especial (!@#$%&/+-=)
				</p>
			</div>

			<BetterButton className='btn btn-primary' style={{ width: '100%' }} loading={loading} onClick={preHandle} >{textoBotao}</BetterButton>
		</div>
	)
}